import {AppState} from '../reducer';
import {IFetchRoom} from '../../incase-domain/rooms/room.player';
import {IRoomRunFile} from '../../incase-domain/proptypes/IRoomRunFile';

export const roomSelector = (state: AppState): IFetchRoom => state.roomRunFileReducer.room;
export const roomRunFileSelector = (state: AppState): IRoomRunFile => state.roomRunFileReducer.roomRunFile;
export const roomUserCountSelector = (state: AppState): number => state.roomRunFileReducer.userCount;
